<div class="page-title-area">
  <div class="d-table">
    <div class="d-table-cell">
      <div class="container">
        <div class="page-title-text">
          <h2>EQUIPE DE LA BSTP</h2>
          <ul>
            <li><a routerLink="/">ACCUEIL</a></li>
            <li><i class="icofont-simple-right"></i></li>
            <li>EQUIPE DE LA BSTP</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>

<section class="team-stats-section pt-100 pb-100">
  <div class="container">
    <div class="stats-grid">
      <div class="stat-card">
        <div class="stat-icon">
          <i class="icofont-users"></i>
        </div>
        <div class="stat-content">
          <h3 class="stat-number" attr.data-count="{{ staffs?.length || 0 }}">0</h3>
          <p class="stat-label">Membres de l'Équipe</p>
        </div>
      </div>
      
      <div class="stat-card">
        <div class="stat-icon">
          <i class="icofont-briefcase"></i>
        </div>
        <div class="stat-content">
          <h3 class="stat-number" attr.data-count="{{ uniqueDepartments?.length || 0 }}">0</h3>
          <p class="stat-label">Départements</p>
        </div>
      </div>
      
      <div class="stat-card">
        <div class="stat-icon">
          <i class="icofont-star"></i>
        </div>
        <div class="stat-content">
          <h3 class="stat-number" attr.data-count="{{ averageExperience || 0 }}">0</h3>
          <p class="stat-label">Années d'Expérience</p>
        </div>
      </div>
      
      <div class="stat-card">
        <div class="stat-icon">
          <i class="icofont-trophy"></i>
        </div>
        <div class="stat-content">
          <h3 class="stat-number" attr.data-count="{{ totalProjects * 10 || 0 }}">0</h3>
          <p class="stat-label">Projets Réalisés</p>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="team-search-section">
  <div class="container">
    <div class="search-container">
      <div class="search-header">
        <h3 class="search-title text-white">
          <i class="icofont-search"></i>
          Trouvez un Membre de l'Équipe
        </h3>
        <p class="search-subtitle">Recherchez par nom, prénom ou fonction</p>
      </div>
      
      <div class="search-form-wrapper">
        <div class="search-input-wrapper">
          <i class="icofont-search search-icon"></i>
          <input 
            type="text" 
            class="form-control search-input" 
            [(ngModel)]="search"
            placeholder="Saisissez le nom, prénom ou fonction..." 
            name="search" 
            autocomplete="off"
            (input)="onSearchInput()"
          >
          <button class="search-btn" type="button">
            <i class="icofont-search"></i>
          </button>
        </div>
        
        <div class="filter-options">
          <select class="form-select department-filter" [(ngModel)]="selectedDepartment" (change)="filterByDepartment()">
            <option value="">Tous les départements</option>
            <option *ngFor="let dept of uniqueDepartments" [value]="dept">{{ getDepartmentName(dept) }}</option>
          </select>
          
          <button class="btn btn-outline-secondary clear-filters" (click)="clearFilters()">
            <i class="icofont-refresh"></i>
            Réinitialiser
          </button>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="team-members-section">
  <div class="container">
    <div class="members-header">
      <div class="results-info">
        <h3 class="results-title">
          <i class="icofont-users"></i>
          Membres de l'Équipe
        </h3>
        <p class="results-count">
          {{ filteredTeam?.length || staffs?.length }} membre(s) trouvé(s)
        </p>
      </div>
    </div>
    
    <!-- Loading Skeleton -->
    <div class="loading-skeleton" *ngIf="!staffs">
      <div class="skeleton-card" *ngFor="let item of [].constructor(5)">
        <div class="skeleton-header">
          <div class="skeleton-avatar"></div>
          <div class="skeleton-info">
            <div class="skeleton-name"></div>
            <div class="skeleton-title"></div>
          </div>
        </div>
        <div class="skeleton-content">
          <div class="skeleton-line"></div>
          <div class="skeleton-line"></div>
          <div class="skeleton-line"></div>
        </div>
      </div>
    </div>
    
    <!-- Team Members List -->
    <div class="members-list" *ngIf="staffs">
      <div 
        class="member-item" 
        *ngFor="let staff of filteredTeam; let i = index"
      >
        <div class="member-photo">
          <img [src]="staff.photo" [alt]="staff.full_name">
        </div>
        
        <div class="member-content">
          <div class="member-info">
            <h3 class="member-name">{{ staff.full_name }}</h3>
            <div class="member-title">
              <i class="icofont-briefcase"></i>
              {{ staff.fonction.name }}
            </div>
            <!-- <div class="member-department" *ngIf="staff.fonction?.name">
              <i class="icofont-building"></i>
              {{ getDepartmentName(staff.fonction.name) }}
            </div> -->
          </div>
          
          <div class="member-description" [innerHTML]="staff.description"></div>
        </div>
        
        <div class="member-actions">
          <button class="btn btn-outline-primary" (click)="viewProfile(staff)">
            <i class="icofont-eye"></i>
            Voir profil
          </button>
          
          <button class="btn btn-primary" (click)="contactMember(staff)">
            <i class="icofont-envelope"></i>
            Contacter
          </button>
        </div>
      </div>
    </div>
    
    <!-- No Results -->
    <div class="no-results-section" *ngIf="staffs && filteredTeam?.length === 0">
      <div class="no-results-content text-center">
        <div class="no-results-icon">
          <i class="icofont-search"></i>
        </div>
        <h3 class="no-results-title">Aucun membre trouvé</h3>
        <p class="no-results-subtitle">
          Aucun membre de l'équipe ne correspond à vos critères de recherche. 
          Essayez de modifier vos filtres.
        </p>
        <div class="no-results-actions">
          <button class="btn btn-primary" (click)="clearFilters()">
            <i class="icofont-refresh"></i>
            Réinitialiser les filtres
          </button>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="organigramme-section">
  <div class="container">
    <div class="organigramme-header text-center">
      <h2 class="organigramme-title">
        <i class="icofont-sitemap"></i>
        Organigramme de la BSTP
      </h2>
      <p class="organigramme-subtitle">
        Découvrez la structure organisationnelle et la hiérarchie de notre équipe
      </p>
    </div>
    
    <img src="assets/img/organigram.jpeg" alt="Organigramme de la BSTP" class="img-fluid" /> 
  </div>
</section>

<section class="team-cta-section">
  <div class="container">
    <div class="cta-content text-center">
      <div class="cta-icon">
        <i class="icofont-handshake"></i>
      </div>
      <h2 class="cta-title text-white">Travaillons Ensemble</h2>
      <p class="cta-subtitle">
        Notre équipe est prête à vous accompagner dans vos projets. 
        Contactez-nous pour discuter de vos besoins.
      </p>
      <div class="cta-actions">
        <a routerLink="/contact" class="btn btn-primary">
          <i class="icofont-envelope"></i>
          Nous Contacter
        </a>
        <a routerLink="/about" class="btn btn-outline-primary">
          <i class="icofont-info-circle"></i>
          En Savoir Plus
        </a>
      </div>
    </div>
  </div>
</section>
